// extracted by mini-css-extract-plugin
export default {"key-id":"tez9V9km5h","keyId":"tez9V9km5h","right-tag":"MGVlXyfyH5","rightTag":"MGVlXyfyH5","none":"nVaLacOHQO"};